import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { motion } from 'framer-motion';
import { FiArrowLeft } from 'react-icons/fi';
import * as categoryService from '../../services/categories';
import * as documentService from '../../services/documents';
import '../../styles/main.scss';

const CategoryDetail = () => {
  const { id } = useParams();

  const {
    data: categoryResponse,
    isLoading: isCategoryLoading,
    isError: isCategoryError,
  } = useQuery(
    ['category', id],
    () => categoryService.getCategory(id),
    {
      enabled: !!id,
    }
  );

  const {
    data: documentsResponse,
    isLoading: isDocumentsLoading,
  } = useQuery(
    ['category-documents', id],
    () =>
      documentService.getDocuments({
        categoryId: id,
        limit: 50,
      }),
    {
      enabled: !!id,
    }
  );

  const category =
    categoryResponse?.category ||
    categoryResponse?.data?.category ||
    categoryResponse;

  const documents = documentsResponse?.data || documentsResponse?.documents || [];

  if (isCategoryLoading) {
    return (
      <div className="dashboard-page category-detail-page">
        <div className="page-header">
          <div className="skeleton skeleton-text" style={{ width: '240px', height: '32px' }} />
        </div>
      </div>
    );
  }

  if (isCategoryError || !category) {
    return (
      <div className="dashboard-page category-detail-page">
        <div className="page-header">
          <div>
            <h1>Category not found</h1>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-page category-detail-page">
      <div className="page-header">
        <div>
          <Link to="/categories" className="btn btn-outline">
            <FiArrowLeft />
            <span>Back to categories</span>
          </Link>
          <h1>{category.name}</h1>
          <p>{category.description || 'No description provided for this category.'}</p>
        </div>
      </div>

      <div className="page-content">
        <div className="document-detail-layout">
          <motion.div
            className="section-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="section-header">
              <h2>Documents in this category</h2>
            </div>
            {isDocumentsLoading ? (
              <div className="loading-placeholder">
                {[...Array(3)].map((_, index) => (
                  <div key={index} className="skeleton skeleton-text" />
                ))}
              </div>
            ) : documents.length === 0 ? (
              <div className="empty-state">
                <p>No documents in this category yet.</p>
              </div>
            ) : (
              <div className="documents-grid">
                {documents.map((doc) => (
                  <motion.div
                    key={doc._id}
                    className="document-card"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                  >
                    <Link to={`/documents/${doc._id}`}>
                      <div className="document-body">
                        <h3>{doc.name}</h3>
                        <p className="document-number">{doc.documentNumber}</p>
                      </div>
                    </Link>
                  </motion.div>
                ))}
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default CategoryDetail;
